import React from 'react';
import './panelists.scss';

function Panelist({ data, image }) {
  const { name, copy } = data;

  return (
    <figure className="panelists__panelist">
      <img alt={`Headshot of ${name}`} src={image}></img>
      <figcaption>
        <div className="panelists__panelist__name">{name}</div>
        <p> {copy}</p>
      </figcaption>
    </figure>
  );
}

export default Panelist;
